import apiSecond from "../apiSecond";

const apiServiceSecond = {
  get(url) {
    return apiSecond.get(url, {
      headers: getSimpleHeaders(),
    });
  },
  post(url, body) {
    return apiSecond.post(url, body, {
      headers: getSimpleHeaders2(),
    });
  },
  put(url, body) {
    return apiSecond.put(url, body, {
      headers: getSimpleHeaders2(),
    });
  },
  delete(url) {
    return apiSecond.delete(url, {
      headers: getSimpleHeaders(),
    });
  },

  getFromFile(url) {
    return apiSecond.get(url, {
      responseType: "blob",
      headers: getSimpleHeaders(),
    });
  },
};

function getSimpleHeaders() {
  return {
    "Content-Type": "application/x-www-form-urlencoded",
    Authorization: `a762bd71-b77c-4c1e-9ebc-7d77ddf94674`,
  };
}

function getSimpleHeaders2() {
  return {
    "Content-Type": "application/json",
    "Accept-Language": "sr",
  };
}

export default apiServiceSecond;
